export class ImagePlagiarismCheckerRequestModel {
  file : File | null=null;
}

export class ImagePlagiarismCheckerResponseModel{
  ai_generated_percentage!:number;
  ai_generators_models!:AiGeneratorModels;
}

export class AiGeneratorModels{
  dalle!:number;
  firefly!:number;
  flux!:number;
  gan!:number;
  gpt4o!:number;
  ideogram!:number;
  imagen!:number;
  midjourney!:number;
  recraft!:number;
  reve!:number;
  stable_diffusion!:number;
  other!:number;
  deepfake!:number;
}
